/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The type of the notification (e.g. BACKUP_JOB_FAILED, RESTORE_JOB_SUCCEEDED, etc.)
*/
export enum NotificationType {
  NotificationTypeUnknown = 'NOTIFICATION_TYPE_UNKNOWN',
  BackupJobFailed = 'BACKUP_JOB_FAILED',
  BackupJobSucceeded = 'BACKUP_JOB_SUCCEEDED',
  RestoreJobSucceeded = 'RESTORE_JOB_SUCCEEDED',
  RestoreJobFailed = 'RESTORE_JOB_FAILED',
  BackupPolicyApplied = 'BACKUP_POLICY_APPLIED',
  BackupPolicyUnapplied = 'BACKUP_POLICY_UNAPPLIED',
  BackupPolicyCreated = 'BACKUP_POLICY_CREATED',
  BackupPolicyUpdated = 'BACKUP_POLICY_UPDATED',
  BackupPolicyDeleted = 'BACKUP_POLICY_DELETED',
  BackupVaultCreated = 'BACKUP_VAULT_CREATED',
  BackupVaultDeleted = 'BACKUP_VAULT_DELETED',
  CloudAccountCreated = 'CLOUD_ACCOUNT_CREATED',
  CloudAccountUpdated = 'CLOUD_ACCOUNT_UPDATED',
  CloudAccountDeleted = 'CLOUD_ACCOUNT_DELETED',
  CloudAccountDeactivated = 'CLOUD_ACCOUNT_DEACTIVATED',
  CloudAccountActivated = 'CLOUD_ACCOUNT_ACTIVATED',
  RansomwareDetectedInResource = 'RANSOMWARE_DETECTED_IN_RESOURCE',
  RansomwareDetectedInSnapshot = 'RANSOMWARE_DETECTED_IN_SNAPSHOT',
  RansomwareInfectionRemediated = 'RANSOMWARE_INFECTION_REMEDIATED',
  ResourceExcludedFromRansomwareDetection = 'RESOURCE_EXCLUDED_FROM_RANSOMWARE_DETECTION',
  RansomwareDetectionExclusionCanceled = 'RANSOMWARE_DETECTION_EXCLUSION_CANCELED',
  ViolationsDetectedOnResources = 'VIOLATIONS_DETECTED_ON_RESOURCES',
  ViolationsResolvedOnResources = 'VIOLATIONS_RESOLVED_ON_RESOURCES',
  IssueMutedOnResource = 'ISSUE_MUTED_ON_RESOURCE',
  IssueUnmutedOnResource = 'ISSUE_UNMUTED_ON_RESOURCE',
  AuditLogCreated = 'AUDIT_LOG_CREATED',
  JobMetricsReportFailed = 'JOB_METRICS_REPORT_FAILED',
  SnapshotUserProtected = 'SNAPSHOT_USER_PROTECTED',
  SnapshotUserUnprotected = 'SNAPSHOT_USER_UNPROTECTED'
}
